import { SearchEngine } from './common'

const defaultFieldSpecifiers = [
  { name: 'abstract', wf: 'F000' },
  { name: 'keywords', wf: '0F00' },
  { name: 'title', wf: '00F0' },
  { name: 'author', wf: '000F' },
  { name: 'articles', ul: '%/a/%' },
  { name: 'papers', ul: '%/p/%' },
  { name: 'chapters', ul: '%/h/%' },
  { name: 'books', ul: '%/b/%' },
  { name: 'software', ul: '%/c/%' },
  { name: 'from', db: true },
  { name: 'to', de: true }
]

const defaultSyntaxGuideUrl = 'https://ideas.repec.org/search.html'

class IdeasEngine extends SearchEngine {
  constructor (fieldSpecifiers) {
    super('IDEAS')
    this.fieldSpecifiers = fieldSpecifiers || defaultFieldSpecifiers
    this.syntaxGuideUrl = defaultSyntaxGuideUrl
  }
  resetQueryParameters () {
    this.wf = '4BFF'
    this.ul = ''
    this.db = ''
    this.de = ''
    this.wfChanged = false
    this.ulChanged = false
    this.dbChanged = false
    this.deChanged = false
  }
  mapOperator (operator) {
    switch (operator.toUpperCase()) {
      case 'AND': return { op: '+', spaces: true }
      case 'OR': return { op: '|', spaces: true }
      case 'NOT': return { op: '~', spaces: true }
    }
    return { op: operator, spaces: true }
  }
  formTerm (text, isNegative, addQuotes, fieldSpecifier) {
    if (fieldSpecifier && fieldSpecifier.length > 0) {
      const s = this.fieldSpecifiers.find(sfs => sfs.name === fieldSpecifier.toLowerCase())
      if (s) {
        if (s.ul && !this.ulChanged) {
          this.ulChanged = true
          this.ul = s.ul
        }
        if (s.wf && !this.wfChanged) {
          this.wfChanged = true
          this.wf = s.wf
        }
        if (s.db && !this.dbChanged) {
          this.dbChanged = true
          this.db = `01/01/${text}`
          return ''
        }
        if (s.de && !this.deChanged) {
          this.deChanged = true
          this.de = `31/12/${text}`
          return ''
        }
      }
    }
    let r = ''
    if (isNegative) {
      r += '-'
    }
    if (addQuotes) {
      r += '"'
    }
    r += text
    if (addQuotes) {
      r += '"'
    }
    return r
  }
  formulateQuery (query) {
    return 'https://ideas.repec.org/cgi-bin/htsearch2?form=extended&wm=wrd&dt=range&ul=' +
      encodeURIComponent(this.ul) +
      '&q=' +
      encodeURIComponent(query) +
      '&cmd=Search!&wf=' +
      encodeURIComponent(this.wf) +
      '&s=R&db=' + this.db +
      '&de=' + this.de
  }
  formulateDisplayQuery (query) {
    const ulSpecific = this.fieldSpecifiers.find(s => s.ul === this.ul)
    const wfSpecific = this.fieldSpecifiers.find(s => s.wf === this.wf)
    const parts = []
    if (ulSpecific) {
      parts.push(ulSpecific.name)
    }
    if (wfSpecific) {
      parts.push(wfSpecific.name)
    }
    if (this.db && this.db.length > 0) {
      parts.push(`From ${this.db}`)
    }
    if (this.de && this.de.length > 0) {
      parts.push(`To ${this.de}`)
    }
    const extra = parts.length > 0 ? ` (${parts.join(', ')})` : ''
    return `${query}${extra}`
  }
  lintQuery (queryGraphData) {
    const m = this.lintFieldSpecifiers(queryGraphData, this.fieldSpecifiers)
    return m ? [m] : []
  }
  getSuggestTermsMetaData () {
    return this.getSuggestTermsDbpediaSettings()
  }
}

export default IdeasEngine



// WEBPACK FOOTER //
// ./src/formulate_queries/IdeasEngine.js